/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_DashboardInputs */

const en_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const es_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const fr_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

const de_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ja_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボード`)
};

const zh_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仪表板`)
};

const ar_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة التحكم`)
};

const id_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor`)
};

const it_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ru_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления`)
};

const pt_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel`)
};

const ko_seller_nav_dashboard = /** @type {(inputs: Seller_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Seller_Nav_DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_dashboard = /** @type {((inputs?: Seller_Nav_DashboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_DashboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_dashboard(inputs)
	if (locale === "es") return es_seller_nav_dashboard(inputs)
	if (locale === "fr") return fr_seller_nav_dashboard(inputs)
	if (locale === "de") return de_seller_nav_dashboard(inputs)
	if (locale === "ja") return ja_seller_nav_dashboard(inputs)
	if (locale === "zh") return zh_seller_nav_dashboard(inputs)
	if (locale === "ar") return ar_seller_nav_dashboard(inputs)
	if (locale === "id") return id_seller_nav_dashboard(inputs)
	if (locale === "it") return it_seller_nav_dashboard(inputs)
	if (locale === "ru") return ru_seller_nav_dashboard(inputs)
	if (locale === "pt") return pt_seller_nav_dashboard(inputs)
	return ko_seller_nav_dashboard(inputs)
});